import {Button, Col, FormGroup, Input, Row} from "reactstrap";
import React, {useState} from "react";
import {v4 as uuid4} from "uuid";

export const TableFilterEditStatus = ({filter, applyFilter, entity}) => {
  const [state, setState] = useState({
    id: filter?.id !== undefined ? filter.id : uuid4(),
    field: filter.field,
    operator: '=', // Always use equals operator for status
    value: filter?.value !== undefined ? filter.value : '',
    label: filter?.label,
    type: filter?.type,
  });

  // Create status options map for different entity types
  const statusOptionsMap = {
    // Default status options (for most entities)
    default: [
      {label: 'Active', value: 1},
      {label: 'Paused', value: 0},
      {label: 'Deleted', value: 2}
    ],

    // User-specific status options
    user: [
      {label: 'Active', value: 1},
      {label: 'Disabled', value: 0},
      {label: 'Deleted', value: 2},
      {label: 'Locked', value: 3},
      {label: 'Invited', value: 4},
      {label: 'Needs Confirmation', value: 5}
    ],

    // User-Access specific status options
    user_access: [
      {label: 'Active', value: 1},
      {label: 'Disabled', value: 0},
      {label: 'Deleted', value: 2},
      {label: 'Locked', value: 3},
      {label: 'Invited', value: 4},
      {label: 'Needs Confirmation', value: 5}
    ],

    // Product-specific status options
    product: [
      {label: 'Active', value: 1},
      {label: 'Disabled', value: 0},
      {label: 'Deleted', value: 2},
      {label: 'Manually Disabled', value: 3}
    ]
  };

  // Get appropriate status options for this entity type
  const statusOptions = statusOptionsMap[entity] || statusOptionsMap.default;

  return (<>
    <FormGroup className="mb-3">
      <Input
        type="select"
        className={'form-control'}
        value={state.value}
        onChange={e => setState({...state, value: e.target.value})}
      >
        <option value="" disabled>Select status</option>
        {statusOptions.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
    </FormGroup>

    <Row>
      <Col>
        <Button
          className="btn-primary float-right"
          disabled={state.value === ''}
          outline={state.value !== ''}
          onClick={() => applyFilter({...state, value: parseInt(state.value, 10)})}
        >
          Apply
        </Button>
      </Col>
    </Row>
  </>)
}
